/**
 * Send-time validation API service — wraps /api/communications/validate-send.
 */

import axios, { AxiosInstance } from 'axios';

import { config as productConfig } from '@/src/config';
export interface ValidateBlock {
  kind: 'template' | 'media_asset' | 'consent' | string;
  subject_id: number;
  subject_name?: string;
  reason: string;
  severity: 'block' | 'warning';
  expiration_date?: string | null;
  policy_source?: string;
  channel?: string;
  override_permission?: string;
}

export interface ValidateSendResult {
  ok: boolean;
  mode: 'standard' | 'regulated';
  blocks: ValidateBlock[];
  warnings: ValidateBlock[];
  checked: {
    template: boolean;
    assets: number;
    members: number;
    channel: string;
    sampled: boolean;
  };
}

class CommunicationValidateAPI {
  private client: AxiosInstance;
  constructor(baseURL: string = (productConfig.weaveinApi.baseUrl ?? '').trim()) {
    this.client = axios.create({ baseURL, headers: { 'Content-Type': 'application/json' } });
    this.client.interceptors.request.use((config) => {
      const token = localStorage.getItem('auth_token');
      const cboId = localStorage.getItem('active_cbo_id');
      if (token) config.headers.Authorization = `Bearer ${token}`;
      if (cboId) config.headers['X-CBO-ID'] = cboId;
      return config;
    });
  }

  async validateSend(payload: {
    template_id?: number;
    asset_ids?: number[];
    member_ids?: number[];
    channel: 'email' | 'sms' | 'voice' | 'mail' | 'whatsapp';
    sample_only?: boolean;
  }) {
    const r = await this.client.post('/api/communications/validate-send', payload);
    return r.data as ValidateSendResult;
  }

  async overrideBlock(payload: {
    template_id?: number;
    asset_ids?: number[];
    blocks: ValidateBlock[];
    reason: string;
  }) {
    const r = await this.client.post('/api/communications/override-block', payload);
    return r.data as { override_token: string; recorded: boolean };
  }
}

export const communicationValidateAPI = new CommunicationValidateAPI();
